import React, { useState, Component, useEffect } from "react";
import Paper from "@material-ui/core/Paper";
import { Table, Button, Spinner } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import SVG from "react-inlinesvg";
import toast from "react-hot-toast";
import Modal from "react-bootstrap/Modal";
import { useFormik } from "formik";
import * as Yup from "yup";
import { baseUrl } from "../../../services/config";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import EditVersion from "./EditVersion";
import PublishModal from "../../components/PublishModal/PublishModal";
// import EditPromo from "../components/EditPromo/EditPromo";
import { useLocation } from "react-router-dom";
import { Switch } from "@material-ui/core";

const ApkVersions = ({ foldable }) => {
  const location = useLocation();

  console.log(location.pathname);
    const Location = location.pathname;
  const [addLoading, setaddLoading] = useState(false);
  const [loading, setloading] = useState(false);
  const authToken = localStorage.getItem("userToken");
  const [deleteLoading, setdeleteLoading] = useState(false);
  const [selectedObject, setselectedObject] = useState({});
  const [show, setShow] = useState(false);
  const [publishModalVisible, setpublishModalVisible] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isPublishable, setisPublishable] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [selectedId, setselectedId] = useState("");
  const [versionCodeList, setversionCodeList] = useState([]);
  const [unPublishedversionCodeList, setunPublishedversionCodeList] = useState(
    []
  );

  const [show2, setShow2] = useState(false);
  const handleClose2 = () => setShow2(false);
  const [editModal, seteditModal] = useState(false);

  const handleShow2 = (id) => {
    setselectedId(id);
    setShow2(true);
  };

  //   const [startDate, setStartDate] = useState(new Date());
  const [statusModal, setStatusModal] = useState(false);

  //multiple select states
  const [MasterChecked, setMasterChecked] = useState(false);
  const [SelectedList, setSelectedList] = useState([]);
  const [status, setStatus] = useState(false);

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };

  const initialValues = {
    version: "",
    version_code: "",
  };

  const LoginSchema = Yup.object().shape({
    version: Yup.string().required("Version is required"),
    // version_code: Yup.string()
    //     .required('Version Code is required')
  });

  const formik = useFormik({
    initialValues,
    validationSchema: LoginSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      setaddLoading(true);
      if (!selectedFile) {
        return toast.error("Please select the Apk");
      }
      const formData = new FormData();

      formData.append("version", values.version);
      //    formData.append('version_code', values.version_code);
      formData.append("status", status ? 1 : 0); // You can update the status value as needed
      formData.append("apk", selectedFile);

      // Now, you can use `formData` in your API request

      let url1 = `${baseUrl}/admin/apk-versions`
  let urlToUse = url1;
    if (Location === "/apk-versions/mobile") {
      urlToUse = `${url1}?mobile_type=2`;
    } else {
      urlToUse = url1;
    }


      fetch(urlToUse, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
        body: formData,
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.metadata.success) {
            toast.success(data.metadata.message);
            setSubmitting(false);
            getCodes();
            setaddLoading(false);
            handleClose();
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              toast.error(msg);
              setaddLoading(false);
              setSubmitting(false);
            });
          }
          console.log(data);
        })
        .catch((err) => {
          setSubmitting(false);
          setaddLoading(false);

          console.error("add codes error", err);
        });
    },
  });

useEffect(() => {
  getCodes();
}, [foldable, location.pathname]);

  const getCodes = () => {
    let url1 = "admin/apk-versions";
    let url2 = "admin/fold-able-versions";
    let urlToUse = url1;
    if (Location === "/apk-versions/mobile") {
      urlToUse = `${url1}?mobile_type=2`;
    } else {
      urlToUse = url1;
    }

    setloading(true);
    fetch(`${baseUrl}/${urlToUse}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setunPublishedversionCodeList(data.payload);
        setloading(false);

        console.log(data);
      })
      .catch((err) => {
        setloading(false);
        console.error("codes error", err);
      });
  };

  const deleteCode = () => {
    setdeleteLoading(true);
    fetch(`${baseUrl}/admin/apk-versions/${selectedId}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.metadata.success) {
          handleClose2();
          getCodes();
          setdeleteLoading(false);
          toast.success(data.metadata.message);
          // setPromocodesList(data.payload);
        }
      })
      .catch((err) => {
        console.error("codes error", err);
        setdeleteLoading(false);
      });
  };
  const changeStatus = () => {
    setdeleteLoading(true);

    fetch(`${baseUrl}/admin/apk-version-status-toggle/${selectedId}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.metadata.success) {
          handleClose2();
          getCodes();
          setdeleteLoading(false);
          setStatusModal(false);
          toast.success(data.metadata.message);
          // setPromocodesList(data.payload);
        }
      })
      .catch((err) => {
        console.error("codes error", err);
        setdeleteLoading(false);
      });
  };

  const editCode = (item, bol) => {
    setselectedObject(item);
    setisPublishable(bol);
    seteditModal(true);
  };
  const openPublishModel = (item) => {
    setselectedObject(item);
    setpublishModalVisible(true);
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (file.type === "application/vnd.android.package-archive") {
        setSelectedFile(file);
      } else {
        alert("Please select a valid APK file.");
        event.target.value = ""; // Clear the input
      }
    }
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          marginBottom: "10px",
        }}
      >
        <Button
          // title={wallapersList.length >= 2 ? "You Can Add Only 2 Side Banners" : ""}
          // disabled={wallapersList.length >= 2 ? true : false}
          className="mr-2 mb-2"
          style={{ width: "100px" }}
          variant="primary"
          onClick={handleShow}
        >
          Add
        </Button>
      </div>

      <div className="row">
        <div className="col-md-12">
          <Paper style={{ padding: "20px" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "10px",
              }}
            >
              <h3>Apk Versions</h3>
            </div>
            <hr style={{ marginLeft: "-20px", marginRight: "-20px" }} />
            <Table responsive>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Version</th>
                  {/* <th>Version Code</th> */}
                  <th>Status</th>
                  <th>Edit</th>
                  <th>Delete</th>
                </tr>
              </thead>
              <tbody>
                {unPublishedversionCodeList &&
                  unPublishedversionCodeList.map((item, index) => (
                    <tr key={item.id}>
                      <td style={{ verticalAlign: "center" }}>{index + 1}</td>
                      <td style={{ verticalAlign: "center" }}>
                        {item.version}
                      </td>
                      {/* <td style={{ verticalAlign: "center" }}>{item.version_code}</td> */}
                      <td style={{ verticalAlign: "center" }}>
                        <Switch
                          checked={item.status}
                          onChange={() => {
                            setselectedId(item.id);
                            setStatusModal(true);
                          }}
                        />
                      </td>

                      <td>
                        <a className="btn btn-icon btn-light btn-sm">
                          <span
                            className="svg-icon svg-icon-md svg-icon-primary"
                            onClick={() => editCode(item, false)}
                          >
                            <SVG
                              src={toAbsoluteUrl(
                                "/media/svg/icons/General/Edit.svg"
                              )}
                            ></SVG>
                          </span>
                        </a>
                      </td>
                      <td>
                        <a className="btn btn-icon btn-light btn-sm">
                          <span
                            className="svg-icon svg-icon-md svg-icon-danger"
                            onClick={() => handleShow2(item.id)}
                          >
                            <SVG
                              src={toAbsoluteUrl(
                                "/media/svg/icons/General/Trash.svg"
                              )}
                            ></SVG>
                          </span>
                        </a>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </Paper>
        </div>
      </div>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Add Apk Version</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form
            onSubmit={formik.handleSubmit}
            className="form fv-plugins-bootstrap fv-plugins-framework"
          >
            <div className="row">
              <div className="col-md-12 m-2">
                <label>Version</label>
                <input
                  className={`form-control form-control-solid h-auto py-2 px-3 ${getInputClasses(
                    "version"
                  )}`}
                  name="version"
                  {...formik.getFieldProps("version")}
                />
                {formik.touched.version && formik.errors.version ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.version}</div>
                  </div>
                ) : null}
              </div>
              {/* <div className="col-md-12 m-2">
                                <label>Version Code</label>
                                <input
                                    className={`form-control form-control-solid h-auto py-2 px-3 ${getInputClasses(
                                        "version_code"
                                    )}`}
                                    name="version_code"
                                    {...formik.getFieldProps("version_code")}
                                />
                                {formik.touched.version_code && formik.errors.version_code ? (
                                    <div className="fv-plugins-message-container">
                                        <div className="fv-help-block">{formik.errors.version_code}</div>
                                    </div>
                                ) : null}
                            </div> */}
              <div className="col-md-8 mb-2">
                <label className="">Apk File</label>
                <input
                  onChange={handleFileChange}
                  type="file"
                  className="form-control"
                  accept=".apk"
                />
              </div>
              <div className="col-md-4" style={{ marginTop: "25px" }}>
                <label>Status</label>
                <Switch
                  checked={status}
                  onChange={(e) => setStatus(e.target.checked)}
                />
              </div>
            </div>

            <Modal.Footer>
              <Button variant="danger" onClick={handleClose}>
                Close
              </Button>
              <button
                id="kt_login_signin_submit"
                type="submit"
                disabled={formik.isSubmitting}
                className={`btn btn-primary`}
              >
                <span style={{ textAlign: "center" }}>Save</span>
                {addLoading && <Spinner animation="border" />}
              </button>
            </Modal.Footer>
          </form>
        </Modal.Body>
      </Modal>

      {/* delete Model */}
      <Modal
        show={show2}
        onHide={handleClose2}
        animation={false}
        size="md"
        // style={{ marginLeft: "140px" }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Apk Version</Modal.Title>
        </Modal.Header>
        <Modal.Body className="row">
          <Form.Group className="mb-3 col-md-12" controlId="formBasicEmail">
            <h3 className="text-center">
              Are you sure ? you want to delete it
            </h3>
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          {deleteLoading ? (
            <Spinner animation="border" />
          ) : (
            <>
              <Button variant="secondary" onClick={handleClose2}>
                Close
              </Button>
              <Button variant="danger" onClick={deleteCode}>
                Delete
              </Button>
            </>
          )}
        </Modal.Footer>
      </Modal>

      <Modal
        show={statusModal}
        onHide={() => setStatusModal(false)}
        animation={false}
        size="md"
        // style={{ marginLeft: "140px" }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Change Status</Modal.Title>
        </Modal.Header>
        <Modal.Body className="row">
          <Form.Group className="mb-3 col-md-12" controlId="formBasicEmail">
            <h3 className="text-center">
              Are you sure ? you want to change the status
            </h3>
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          {deleteLoading ? (
            <Spinner animation="border" />
          ) : (
            <>
              <Button variant="secondary" onClick={() => setStatusModal(false)}>
                Close
              </Button>
              <Button variant="primary" onClick={changeStatus}>
                Change
              </Button>
            </>
          )}
        </Modal.Footer>
      </Modal>

      {/* delete Model */}
      {editModal && (
        <EditVersion
          foldable={foldable}
          isPublishable={isPublishable}
          visible={editModal}
          selectedObject={selectedObject}
          hide={() => seteditModal(false)}
          reload={() => getCodes()}
        />
      )}

      <PublishModal
        foldable={foldable}
        closeModal={() => setpublishModalVisible(false)}
        modalVisible={publishModalVisible}
        item={selectedObject}
        reload={() => getCodes()}
      />
    </div>
  );
};

export default ApkVersions;
